export const DEFAULT_CUSTOMER_SEARCH = {
  current: 1,
  pageSize: 20
}
